import { Grid } from "@mui/material";
import EditInterchangeDialog from "./EditInterchangeDialog";
import MoveInterchangeDialog from "./MoveInterchangeDialog";
import DeleteInterchangeDialog from "./DeleteInterchangeDialog";
import { dialogTypes, InterchangeOpenDialog } from "../../data";
import { InventoryActivityReportViewVO } from '../../../../types/model/valueObject/InventoryActivityReportViewVO';

interface DialogProps {
  interchange: InventoryActivityReportViewVO,
  openDialog: InterchangeOpenDialog,
  onClose: () => void;
}

const SupplierInterchangeDialogWrapper = (props: DialogProps) => {

  const {interchange, openDialog, onClose} = props;

  const determineOpenDialog = (name: string) => {
    return openDialog.open && name === openDialog.type && Boolean(interchange)
  }

  return <Grid>
    <EditInterchangeDialog open={determineOpenDialog(dialogTypes.EDIT)} interchange={interchange} onAction={openDialog.action} onClose={onClose} />
    <MoveInterchangeDialog open={determineOpenDialog(dialogTypes.MOVE)} interchange={interchange} onAction={openDialog.action} onClose={onClose} />
    <DeleteInterchangeDialog open={determineOpenDialog(dialogTypes.DELETE)} interchange={interchange} onAction={openDialog.action} onClose={onClose} />
  </Grid>
}

export default SupplierInterchangeDialogWrapper;